import { useMemo } from 'react';
import { parseCookies } from '@cian/utils';

import { useAppSelector as useSelector } from '../../../../types';
import { selectRegionId } from '../../../../selectors/selectRegionId';

const SESSION_REGION_ID_COOKIE_KEY = 'session_region_id';
const FOREVER_REGION_ID_COOKIE_KEY = 'forever_region_id';

export function useRegion() {
  const regionId = useSelector(selectRegionId);

  const parsedCookies = parseCookies(document.cookie);
  const id =
    parseInt(parsedCookies[SESSION_REGION_ID_COOKIE_KEY], 10) ||
    parseInt(parsedCookies[FOREVER_REGION_ID_COOKIE_KEY], 10) ||
    regionId;

  return useMemo(() => ({ id }), [id]);
}
